import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementVNode as _createElementVNode, createSlots as _createSlots } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = {
  class: "flex flex-justify-end",
  style: {"width":"100%"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_pagination = _resolveComponent("pagination")!
  const _component_app_page = _resolveComponent("app-page")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_app_page, null, _createSlots({
    main: _withCtx(({ height }) => [
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        heigh: height,
        border: "",
        data: _ctx.tableData
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            label: "序号",
            prop: "agreementId"
          }, {
            default: _withCtx(({ row }) => [
              (_ctx.$has(_ctx.permissionConfig.BJ))
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    type: "text",
                    onClick: ($event: any) => (_ctx.jumpDetail({id: row.agreementId}))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(row.agreementId), 1)
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(row.agreementId), 1))
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "协议标题",
            prop: "title"
          }),
          _createVNode(_component_el_table_column, {
            label: "协议类型名称",
            prop: "typeName"
          }),
          _createVNode(_component_el_table_column, {
            label: "协议类型",
            prop: "type"
          }),
          _createVNode(_component_el_table_column, {
            label: "状态",
            prop: "state"
          }, {
            default: _withCtx(({ row }) => [
              _createTextVNode(_toDisplayString(_ctx.filters.getEnumLabel(_ctx.DICTIONARY_STATUS_LIST, row.state)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "操作",
            prop: "state"
          }, {
            default: _withCtx(({ row }) => [
              (_ctx.$has(_ctx.permissionConfig.QYJY))
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    type: "text",
                    onClick: ($event: any) => (_ctx.handleState(
                row.agreementId,
                row.state === _ctx.DICTIONARY_STATUS_ENUM.ENABLE
                  ? _ctx.DICTIONARY_STATUS_ENUM.DISENABLE
                  : _ctx.DICTIONARY_STATUS_ENUM.ENABLE
              ))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(row.state === _ctx.DICTIONARY_STATUS_ENUM.ENABLE ? '停用' : '启用'), 1)
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 2
      }, 1032, ["heigh", "data"])), [
        [_directive_loading, _ctx.tableLoading]
      ])
    ]),
    ffooter: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_pagination, {
          total: _ctx.tableTotal,
          "current-page": _ctx.params.pageNum,
          "page-size": _ctx.params.pageSize,
          onSizeChange: _ctx.handleSizeChange,
          onCurrentChange: _ctx.handleCurrentChange
        }, null, 8, ["total", "current-page", "page-size", "onSizeChange", "onCurrentChange"])
      ])
    ]),
    _: 2
  }, [
    (_ctx.$has(_ctx.permissionConfig.XZ))
      ? {
          name: "header",
          fn: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.jumpDetail()))
            }, {
              default: _withCtx(() => [
                _createTextVNode("新建")
              ]),
              _: 1
            })
          ]),
          key: "0"
        }
      : undefined
  ]), 1024))
}